var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data_seted)?_c('div',{staticClass:"view article-view"},[_c('add-to-cart-modal'),_c('advise'),_c('article-view'),_c('similars'),_c('contact-info')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }